import { render, staticRenderFns } from "./ShareholderDeleteProvider.vue?vue&type=template&id=2dc0d534&scoped=true&"
import script from "./ShareholderDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./ShareholderDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0d534",
  null
  
)

export default component.exports